import { Injectable } from '@angular/core';


@Injectable()
export class PaginationConfig {
  size = 5;
  pageSizeOptions = [5, 10, 25, 100];

}
